import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

interface LeftRightAnimationProps {
  children: ReactNode;
}

const LeftRightAnimation: React.FC<LeftRightAnimationProps> = ({ children }) => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: false,
  });

  const variants = {
    hidden: { opacity: 0, x: 25 },   // Come from bottom
    visible: { opacity: 1, x: 0 },    // In place
    exit: { opacity: 0, x: 25 },    // Exit to top
  };

  return (
    <motion.div
      ref={ref}
      variants={variants}
      initial="hidden"
      animate={inView ? 'visible' : 'exit'}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      style={{ margin: '50px 0' }}
    >
      {children}
    </motion.div>
  );
};

export default LeftRightAnimation;